import { render, staticRenderFns } from "./DetalhesdaReserva.vue?vue&type=template&id=734679ca&class=bg-white"
import script from "./DetalhesdaReserva.vue?vue&type=script&lang=js"
export * from "./DetalhesdaReserva.vue?vue&type=script&lang=js"
import style0 from "./DetalhesdaReserva.vue?vue&type=style&index=0&id=734679ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports